import { useEffect } from 'react';
import type { RefObject } from 'react';

const DEFAULT_BORDER_COLOR = 'rgba(0, 0, 0, 0.23)';
const FOCUS_BORDER_COLOR = '#00AC4F';

export const usePeoplePickerStyles = (
    peoplePickerRef: RefObject<HTMLDivElement | null>,
    enabled: boolean = true,
    triggerKey?: string | number
) => {
    useEffect(() => {
        if (!enabled) return;

        const customizePeoplePicker = () => {
            const mgtPicker = peoplePickerRef.current?.querySelector('mgt-people-picker');
            if (!mgtPicker?.shadowRoot) return;

            const selectedList = mgtPicker.shadowRoot.querySelector('.selected-list-item') as HTMLElement | null;
            if (selectedList) {
                selectedList.style.marginTop = '10px';
            }

            const fluentTextField = mgtPicker.shadowRoot.querySelector('fluent-text-field') as HTMLElement | null;
            if (!fluentTextField?.shadowRoot) return;
            // Hide search icon
            const searchIcon = fluentTextField.querySelector('.search-icon') as HTMLElement | null;
            const searchTextBox = fluentTextField.shadowRoot.querySelector('.control') as HTMLElement | null;
            console.log("fluentTextField", fluentTextField);
            console.log("searchTextBox", searchTextBox);

            if (searchTextBox) {
                // Disable autocomplete and related features
               
                searchTextBox.setAttribute('autocomplete', 'off');  // some browsers read attrs
                searchTextBox.setAttribute('autocapitalize', 'off');
                searchTextBox.setAttribute('autocorrect', 'off');   // non-standard but respected on iOS
                searchTextBox.spellcheck = false;
            }
            
            if (searchIcon) searchIcon.style.display = 'none';

            const inputControl = fluentTextField.shadowRoot.querySelector('input#control') as HTMLInputElement | null;
            if (!inputControl) return;

            const placeholderStyleId = 'mgt-placeholder-font-style';
            if (!fluentTextField.shadowRoot.getElementById(placeholderStyleId)) {
                const styleEl = document.createElement('style');
                styleEl.id = placeholderStyleId;
                styleEl.textContent = `
                    input#control::placeholder {
                        font-size: 14px;
                    }
                `;
                fluentTextField.shadowRoot.appendChild(styleEl);
            }

            // Apply base styles
            Object.assign(inputControl.style, { ...{ padding: '4px 14px', fontSize: '14px' } });
            Object.assign(fluentTextField.style, {
                border: `0.5px solid ${DEFAULT_BORDER_COLOR}`,
                borderBottom: `0.5px solid ${DEFAULT_BORDER_COLOR}`,
                borderRadius: '4px',
                transition: 'border-color 0.2s ease'
            });

            // Focus/hover style handlers
            const setActiveStyle = () => {
                fluentTextField.style.borderColor = FOCUS_BORDER_COLOR;
                fluentTextField.style.background = '#FFFFFF';
                fluentTextField.style.borderBottomColor = FOCUS_BORDER_COLOR;
            };

            const setDefaultStyle = () => {
                fluentTextField.style.borderColor = DEFAULT_BORDER_COLOR;
                fluentTextField.style.borderBottomColor = DEFAULT_BORDER_COLOR;
                fluentTextField.style.outline = 'none';
            };

            // Add event listeners
            fluentTextField.addEventListener('mouseenter', () => {
                fluentTextField.style.borderColor = FOCUS_BORDER_COLOR;
            });
            fluentTextField.addEventListener('mouseleave', () => {
                if (document.activeElement !== inputControl) setDefaultStyle();
            });
            inputControl.addEventListener('focus', setActiveStyle);
            inputControl.addEventListener('blur', setDefaultStyle);
        };

        const timeoutId = setTimeout(customizePeoplePicker, 100);
        return () => clearTimeout(timeoutId);
    }, [peoplePickerRef, enabled, triggerKey]);
};
